import React from "react";

const DICE = `${import.meta.env.BASE_URL}assets/img/dice`;

/**
 * Reference result body for Sic Bo (sicbo / sicbo2):
 *   .row.row5.worli-result > col-lg-7 (one dice image per card value) + col-lg-5 (Desc = rdesc, Win = win)
 */
export default function SicboResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim()).filter(Boolean);
  return (
    <div className="row row5 worli-result">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center w-100">
            <div className="casino-result-cards">
              {cards.map((c, i) => (
                <div key={i} className="casino-result-cards-item">
                  <img src={`${DICE}/dice${c}.png`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Desc</div> <div>{t1?.rdesc}</div>
          </div>{" "}
          <div className="casino-result-desc-item">
            <div>Win</div> <div>{t1?.win}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
